"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withContextMenu", {
  enumerable: true,
  get: function get() {
    return _ContextMenu["default"];
  }
});
var _ContextMenu = _interopRequireDefault(require("./ContextMenu"));